
import React, { useEffect, useState } from "react";
import { Box, Button, Typography, Container, Stack, Grid } from "@mui/material";
import financialImage from "../../../../../Assets/financialImage.svg"; // Ensure this is the correct path
import financialImageBackground from "../../../../../Assets/financialImageBackgroud.svg"; // Ensure this is the correct path
import { useDispatch, useSelector } from "react-redux";
import actions from "../../../../../ReduxStore/actions";
import ModalApproveButton from "../../../../../Components/ModalButton/HomeSectionButton/ModalApproveButton";
import { adminUrl } from "../../../../../constants";

const AreYouFinancial = ({ referralsDates, values, onClose  ,sectionNameForApproveAndReject}) => {



    const [responseData, setResponseData] = useState()

    console.log(values, "valuesssss")
    console.log(responseData, "responseDatattaatatatt")
    const TableId = useSelector((state) => state.Table.TableId);

    console.log(TableId, "TebleIddddd")

    const dispatch = useDispatch()

    useEffect(() => {
        console.log(TableId, "TebleIddddd111")

        if (TableId && !values) {
            console.log(TableId, "TebleIddddd222")

            const fetchData = async () => {
                const data1 = {
                    data: {},
                    method: "get",
                    apiName: `getHomeSectionById/${TableId}`,
                };
                const response = await dispatch(actions.GETHOMESECTIONBYID(data1));

                console.log(response, "responseresponse")

                if (response?.payload?.message === "Home section retrieved successfully.") {
                    console.log("hiiii")

                    setResponseData(response?.payload?.data)
                    // setUploadedFile({
                    //     fileUrl: response?.payload?.data.additional_data[0]?.banner,
                    //     type: "img",
                    //     progress: 100,
                    // }
                    // )
                    // console.log(response?.payload?.data.additional_data[0]?.banner,"yhfuwrfrkjrw")
                }
            };
            fetchData();
        }

    }, []);



    return (
        <Box>
            <Box
                sx={{
                    position: "relative",
                    background: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    overflow: "hidden",
                    padding: "50px 0px",
                }}
            >
                <Container maxWidth="lg" sx={{ zIndex: 2 }}>
                    <Grid
                        container
                        xs={12}
                    >
                        <Grid
                            item
                            md={4}
                            sx={{
                                display: "flex", // Flexbox to apply justifyContent and alignItems
                                justifyContent: "center", // Center horizontally
                                alignItems: "center", // Center vertically
                                backgroundImage: `url(${financialImageBackground})`, // Set background image
                                backgroundSize: "contain", // Make the image cover the entire container
                                backgroundRepeat: "no-repeat", // Prevent the image from repeating
                                backgroundPosition: "center", // Center the image
                                height: "300px", // Ensure it covers the full height of the container
                                width: "100%", // Ensure it covers the full width of the container
                                position: "relative", // Needed for z-index control
                                zIndex: 0, // Keep it behind other elements
                                display: {
                                    xs: "none", // Hide on extra small screens
                                    sm: "flex", // Show on small screens and above
                                },
                            }}
                        >
                            <img src={`${adminUrl}${values?.image || responseData?.additional_data?.[0]?.banner}`} alt="Refer" style={{ height: "250px", zIndex: 1, position: "relative" }} />
                        </Grid>

                        {/* Left Section */}
                        <Grid
                            item
                            md={8}
                            sx={{ color: "#fff", display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <Box>
                                <Typography
                                    variant="h1"
                                    textAlign="start"
                                    sx={{
                                        // fontSize: "40px",
                                        fontSize: { xs: "30px", md: "40px" },

                                        // maxWidth: "600px",
                                        color: "#3B4056",
                                        mb: 1,

                                    }}
                                >
                                    {responseData?.heading || values?.title || "Default Sub-heading"}
                                    {/* Are you a Financial Consultant ? */}

                                </Typography>

                                <Typography
                                    variant="h3"
                                    textAlign="start"
                                    sx={{
                                        mt: 2,
                                        fontSize: { xs: "16px", md: "18px" },

                                        fontWeight: "600",
                                        // maxWidth: "600px",
                                        color: "#C38F51",
                                        mb: 1,

                                    }}
                                >
                                    {responseData?.sub_heading || values?.sub_text || "Default Sub-heading"}
                                    {/* Join us and become a financial Consultant to generate a hussle free income */}

                                </Typography>



                                <Typography
                                    variant="body1"
                                    textAlign="start"
                                    sx={{
                                        mt: 2,

                                        mb: 3,
                                        lineHeight: "1.6",
                                        color: "#7A7A7A",
                                        maxWidth: "600px",
                                        fontSize: "14px",
                                        letterSpacing: "0px",
                                        opacity: 1,
                                    }}
                                >
                                    {responseData?.content || values?.content || "Default Sub-heading"}
                                    {/* Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown */}

                                </Typography>

                                <Stack spacing={2} direction="row" sx={{ display: "flex", justifyContent: "end", alignItems: "end" }}>
                                    <Button
                                        variant="contained"
                                        sx={{
                                            textTransform: "none",
                                            color: "white",
                                            boxShadow: "none",

                                            padding: "0px 60px",
                                            height: "40px",
                                            borderRadius: "23px",
                                            background: "#3B4056 0% 0% no-repeat padding-box",
                                            "&:hover": {
                                                backgroundColor: "#C38F51",
                                            },
                                        }}
                                    >
                                        {responseData?.additional_data?.[0]?.primary_button_text || values?.primary_button_text || "Join us"}

                                    </Button>
                                </Stack>
                            </Box>
                        </Grid>
                        {/* Right Section: Image */}

                    </Grid>
                </Container>
            </Box>
            <ModalApproveButton approveStatus={responseData?.approval_status} values={values} onClose={onClose} sectionNameForApproveAndReject={sectionNameForApproveAndReject}/>
        </Box>
    );
};

export default AreYouFinancial;
